import React from "react";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import { widgetKeys } from "../../../constants";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { administrationBulkAssignmentTool as bulkAssignmentToolRoute } from "../../../routes/AdminRoutes";
import { withRouter } from "react-router-dom";
import { Button, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: "100%"
  }
}));

const QuickAction = ({ dashboard, history }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const redirectToBulkAssignmentTool = () => {
    history.push(bulkAssignmentToolRoute);
  };

  return (
    <DashboardWidgetContainer
      dashboard={dashboard}
      widgetKey={widgetKeys.quick}
      title={t("quickActionWidget.title")}
    >
      <Box
        alignSelf="center"
        display="flex"
        flexDirection="column"
        className={classes.fullWidth}
      >
        <Button
          onClick={redirectToBulkAssignmentTool}
          color="primary"
          variant="contained"
          className={classes.fullWidth}
        >
          {t("quickActionWidget.bulkButtonTitle")}
        </Button>
      </Box>
    </DashboardWidgetContainer>
  );
};

export default withRouter(QuickAction);

QuickAction.propTypes = {
  dashboard: PropTypes.string
};
